module.exports = {
	"version": "0.16.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/truffle-contract/~/web3/lib/version.json
// module id = 1224
// module chunks = 0